'use client'
import { LoadingButton } from '@/components/atomic'
import Basiclayout from '@/components/atomic/Basiclayout'
import Card from '@/components/atomic/Card'
import Heading from '@/components/atomic/Heading'
import { ICONS } from '@/constants/constants'
import Image from 'next/image'
import React, { useEffect, useState } from 'react'
import { viewFares } from '@/lib/api/trip'
import Link from 'next/link'
import { useToastContext } from '@/components/ui/ToastProvider';

// Define the fare data structure with dynamic pricing
const getFaresData = (faresFromAPI: any[] = []) => {


  return [
    {
      icon: ICONS.car,
      title: 'Vehicle + Driver',
      price: faresFromAPI.find(f => f.type === 'VEHICLE')?.price ? `$${faresFromAPI.find(f => f.type === 'VEHICLE')?.price}` : '',
      subtitle: 'All vehicle types',
      features: [
        'Includes one adult driver',
        'Any vehicle size',
      ],
    },
    {
      icon: ICONS.person,
      title: 'Adult',
      price: faresFromAPI.find(f => f.type === 'ADULT')?.price ? `$${faresFromAPI.find(f => f.type === 'ADULT')?.price}` : '',
      subtitle: 'Ages 19–64',
      features: [
        'Standard seating',
        'Onboard amenities',
      ],
    },
    {
      icon: ICONS.studenthat,
      title: 'Student/ Senior',
      price: faresFromAPI.find(f => f.type === 'SENIOR')?.price ? `$${faresFromAPI.find(f => f.type === 'SENIOR')?.price}` : '',
      subtitle: 'Valid ID required',
      features: [
        'Students with valid ID',
        'Seniors 55+',
      ],
    },
    {
      icon: ICONS.child,
      title: 'Child',
      price: faresFromAPI.find(f => f.type === 'CHILDREN')?.price === '0' ? 'Free' : (faresFromAPI.find(f => f.type === 'CHILDREN')?.price ? `$${faresFromAPI.find(f => f.type === 'CHILDREN')?.price}` : 'Free'),
      subtitle: 'Ages 0–4',
      features: [
        'Must be accompanied',
        'Max 2 per adult',
      ],
    },
  ];
};


const FareNotes = () => (
  <div className="bg-gray-100 rounded-lg p-6 w-full flex items-start gap-2">
    <Image src={ICONS.info} alt='info' width={15} height={15} className='mt-1' />
    <div>
      <div className="flex items-center mb-2">

        <span className="font-medium text-gray-800 text-base">Important Information</span>
      </div>
      <ul className="list-disc pl-5 text-sm text-gray-600 space-y-1">
        <li> All fares are one-way and include taxes</li>
        <li>Valid ID required for discounted fares</li>
        <li>Children must be accompanied by a fare-paying adult</li>

      </ul>
    </div>
  </div>
);
const getIconSize = (idx: number) => {
  switch (idx) {
    case 0:
      return { width: 40, height: 40 };
    case 1:
      return { width: 30, height: 30 };
    case 2:
      return { width: 40, height: 40 };
    case 3:
      return { width: 20, height: 20 };
    default:
      return { width: 24, height: 24 };
  }
};

const Schedule = () => {
  const [faresData, setFaresData] = useState(getFaresData());
  const { toast } = useToastContext();
  useEffect(() => {
    const fetchFares = async () => {
      try {
        const response = await viewFares();
        if (response && response.success && response.data?.fares) {
          setFaresData(getFaresData(response.data.fares));
        }
      } catch (error: any) {
        // Keep default fares on error
        toast.error(error.response?.data?.message || 'Something went wrong. Please try again.');
      }
    };

    fetchFares();
  }, []);

  return (
    <Basiclayout className='max-md:pr-0 max-md:pl-0'>
      <Heading className='mt-10 max-md:hidden' heading='PASSENGER FARES' subheading="One-way trip between AER and TUK" />
      <div className='max-md:block hidden pt-10 pr-5 pl-5'>
        <h1 className='text-2xl font-semibold font-rakesly uppercase'>Passenger Fares</h1>
        <p className='text-gray-600'>One-way trip between Lax Kw'alaams and Prince Rupert Port</p>
      </div>
      <Card className='mt-10 flex flex-col gap-5 mb-10'>
        <div className='grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-4 gap-6 w-full'>
          {faresData.map((fare, idx) => (
            <Card key={idx} className='flex flex-col items-center border border-gray-200 text-center p-8 rounded-xl h-full'>
              <Image
                src={fare.icon}
                alt={fare.title}
                width={getIconSize(idx).width}
                height={getIconSize(idx).height}
                className='mb-3'
              />
              <div className='text-xl text-center font-normal text-gray-600 mb-1'>{fare.title}</div>
              <div className='text-3xl font-normal mb-1'>{fare.price}</div>
              <div className='text-sm text-gray-500 mb-4'>{fare.subtitle}</div>
              <ul className='text-sm text-gray-600 space-y-1 text-left w-full max-w-xs mx-auto'>
                {fare.features.map((feature, i) => (
                  <li key={i} className='flex items-start gap-2'>
                    <Image src={ICONS.tick} alt='tick' height={20} width={20} />
                    <span>{feature}</span>
                  </li>
                ))}
              </ul>

            </Card>
          ))}
        </div>

        <FareNotes />

        <div className='flex justify-start w-full '>
          <Link href="/" className='max-md:w-full'>
            <LoadingButton className='max-md:w-full '>
              <span className='font-semibold px-10 py-1'>Book a trip</span>
            </LoadingButton>
          </Link>
        </div>
      </Card>
    </Basiclayout>
  )
}

export default Schedule